import React from "react";
import { PartitionRoleManageContent } from "../Component/PartitionRoleManageContent";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";

const PartitionRoleManage = () => {
  const seoData = getSEOData("/partition-management");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <PartitionRoleManageContent />
    </>
  );
};

export default PartitionRoleManage;
